module.exports = __webpack_public_path__ + "img/radio5.584edb59.png";